import { render, staticRenderFns } from "./BumperBoxCheckOut.vue?vue&type=template&id=4b5566ca&scoped=true&"
import script from "./BumperBoxCheckOut.vue?vue&type=script&lang=js&"
export * from "./BumperBoxCheckOut.vue?vue&type=script&lang=js&"
import style0 from "./BumperBoxCheckOut.vue?vue&type=style&index=0&id=4b5566ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5566ca",
  null
  
)

export default component.exports